// extracted by mini-css-extract-plugin
export var contentContainer = "etaireia-module--contentContainer--2CabT";
export var content = "etaireia-module--content--1l4wa";
export var img = "etaireia-module--img--25hpT";